import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 全局配置
Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局挂载axios
Vue.prototype.$http = axios.create({
    timeout: 10000,
    headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// axios响应拦截（统一错误处理）
Vue.prototype.$http.interceptors.response.use(
    res => res.data,
    err => {
        Vue.prototype.$message.error(err.message || '请求失败')
        return Promise.reject(err)
    }
)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')